"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewSource = void 0;
var ReviewSource;
(function (ReviewSource) {
    ReviewSource[ReviewSource["TripAdvisor"] = 0] = "TripAdvisor";
})(ReviewSource || (exports.ReviewSource = ReviewSource = {}));
//# sourceMappingURL=ReviewSource.js.map